import {
	DefaultRawRichTextContentBlockStyleAttribute,
	RawRichTextContentDocumentRootElementName,
} from '../../../extViewmodels';

/**
 * HTML-encodes text content to prevent XSS while preserving the text.
 * Only encodes special HTML characters, not the HTML tags we create.
 */
export function escapeHtml(text: string): string {
	if (!text) return '';
	return text
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#039;');
}

/**
 * Converts plain text to properly formatted HTML for rich content storage.
 * - Wraps each paragraph in <p> tags with the default block styling
 * - HTML-encodes text content for XSS safety
 * - Handles line breaks: double newlines create new paragraphs, single newlines create <br> tags
 */
export function convertTextToHtml(text: string): string {
	if (!text) return '';

	// Use default block style but add margin-bottom for spacing between paragraphs
	const style = DefaultRawRichTextContentBlockStyleAttribute.replace('margin:0;', 'margin:0 0 12px 0;');

	// Split by double line breaks for paragraphs
	const paragraphs = text
		.split(/\n\n+/)
		.map(para => {
			if (!para.trim()) return '';
			// Handle single line breaks within a paragraph as <br> tags
			const lines = para
				.split('\n')
				.map(line => escapeHtml(line))
				.join('<br>');
			return `<p style="${style}">${lines || '&nbsp;'}</p>`;
		})
		.filter(p => p)
		.join('');

	return paragraphs || `<p style="${style}">&nbsp;</p>`;
}

/**
 * Wraps HTML content in lev-content document tags for rich content storage.
 */
export function wrapInDocumentTags(htmlContent: string): string {
	return `<${RawRichTextContentDocumentRootElementName}>${htmlContent}</${RawRichTextContentDocumentRootElementName}>`;
}
